import type {
    Field007DocumentCategory,
    Field008CataloguingSource,
    Field008DocumentType,
    Field008PublicationStatus,
    Field008RecordModification,
    LabeledIdentified
} from 'typings/portaro.be.types';

export interface Field7Model {
    documentCategory: Field007DocumentCategory
    // + dynamic properties <positions1, ...>
}

export interface Field8Model extends Field8SharedPartModel {
    documentType: Field008DocumentType;
    // + dynamic properties <positions18, ..., position34>
}

export interface Field8SharedPartModel {
    fileCreationDate: string;
    publicationStatus: Field008PublicationStatus;
    date1: string;
    date2: string;
    placeOfPublication: LabeledIdentified<string>;
    language: LabeledIdentified<string>;
    recordModification: Field008RecordModification;
    cataloguingSource: Field008CataloguingSource;
}

export const DEFAULT_FILL_CHARACTER = '|'
export const EMPTY_SYMBOLS = [DEFAULT_FILL_CHARACTER, ' ', '-', '#'];
export const UNDEFINED_POSITION_CHARACTER = ' ';